const pre = '/super/';

export default {
    path: '/super',
    title: '超级管理员',
    header: '',
    icon: 'md-color-palette',
    children: [
        {
            path: `${pre}workspace`,
            title: '工作台'
        },
    ]
}
